import React from 'react';
import { Chip } from '@mui/material';

interface PipelineBiologicalTargetProps {
  targets: string[];
  stated: boolean;
}

export const PipelineBiologicalTarget: React.FC<PipelineBiologicalTargetProps> = ({
  targets,
  stated,
}) => {
  const verifiedTargets = targets.filter((target) => target.trim().length > 0);

  if (stated && verifiedTargets.length > 0) {
    return (
      <Chip
        size="small"
        color="success"
        variant="outlined"
        label={verifiedTargets.join(', ')}
      />
    );
  }

  return <Chip size="small" variant="outlined" label="Not stated" />;
};
